import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Col, Row, Form, Button, Label, Input } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";
import moment from "moment";
import Header from "../../../layout/Header/Header";
import CapturaMateriales, { renglonVacio, renglonesParaEnviar, telaSinColor } from "../CapturaMateriales";
import { limiteDisponible, coloresConExistencia, materialesConExistencia } from "../existencias";

/**
 * Salida de tela y habilitacion por CANTIDAD (merma, muestras, venta de tela...).
 *
 * Antes se escaneaba el QR de cada rollo; ahora se elige el material, el color
 * y cuanto sale, igual que la habilitacion. Lo apartado para pedidos no se
 * puede sacar.
 */
function SalidaMaterialesCreate() {
  const { user } = useContext(AuthContext);
  const URL_AREAS = process.env.REACT_APP_URL_AREAS;
  const URL_TELAS = process.env.REACT_APP_URL_TELAS;
  const URL_HABILITACION = process.env.REACT_APP_URL_HABILITACION;
  const URL_COLORES = process.env.REACT_APP_URL_COLORES;
  const URL_INVENTARIOS_MATERIALES = process.env.REACT_APP_URL_INVENTARIOS_MATERIALES;
  const URL_SALIDA_MATERIALES = process.env.REACT_APP_URL_SALIDA_MATERIALES;

  const [fecha, setFecha] = useState(moment().format("YYYY-MM-DD"));
  const [observaciones, setObservaciones] = useState("");
  const [area, setArea] = useState("");
  const [areas, setAreas] = useState([]);
  const [telas, setTelas] = useState([]);
  const [habilitacion, setHabilitacion] = useState([]);
  const [colores, setColores] = useState([]);
  const [existencias, setExistencias] = useState([]);
  const [renglones, setRenglones] = useState([renglonVacio("Telas")]);
  const [guardando, setGuardando] = useState(false);

  const cab = () => ({ headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } });

  useEffect(() => {
    const pide = (url, set) => axios.get(url, cab()).then((r) => set(r.data)).catch((e) => console.log(e));
    axios.get(URL_AREAS, cab()).then((r) => {
      const bodegas = r.data.filter((a) => (a.tipo || "Bodega") === "Bodega");
      setAreas(bodegas);
      const principal = bodegas.find((a) => a.name === "Almacen") || bodegas[0];
      if (principal) setArea(principal._id);
    });
    pide(URL_TELAS, setTelas);
    pide(URL_HABILITACION, setHabilitacion);
    pide(URL_COLORES, setColores);
  }, []);

  useEffect(() => {
    if (!area) return;
    let vigente = true; // si cambian de almacen, la respuesta anterior ya no vale
    axios
      .get(`${URL_INVENTARIOS_MATERIALES}?areas=${area}`, cab())
      .then((r) => vigente && setExistencias(r.data))
      .catch((e) => console.log(e));
    return () => { vigente = false; };
  }, [area]);

  async function guardar(e) {
    e.preventDefault();
    const sinColor = telaSinColor(renglones);
    if (sinColor) return Swal.fire({ icon: "warning", title: "Falta el color de una tela" });
    const envio = renglonesParaEnviar(renglones);
    if (!envio.length) return Swal.fire({ icon: "warning", title: "Captura al menos un material con cantidad" });

    setGuardando(true);
    try {
      const { data } = await axios.post(URL_SALIDA_MATERIALES, { fecha, observaciones, areas: area, renglones: envio }, cab());
      await Swal.fire({ icon: "success", title: `Salida ${data.idSalidaTela} registrada` });
      window.location.href = "/ListadoSalidaTelas";
    } catch (error) {
      const info = error.response?.data || {};
      Swal.fire({ icon: "error", title: "No se pudo registrar la salida", text: info.message || error.message });
      setGuardando(false);
    }
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_telas ? (
        <div className="card container col-10">
          <div className="page-header">
            <div>
              <h3 className="page-title">
                <i className="fas fa-sign-out-alt" style={{ marginRight: 8, color: "#ef4444" }} />
                Nueva Salida de Material
              </h3>
              <p className="page-subtitle">Elige el material, el color y cuanto sale. Sin rollos ni QR.</p>
            </div>
          </div>
          <Form onSubmit={guardar}>
            <Row>
              <Col md={3}>
                <Label>Fecha</Label>
                <Input type="date" value={fecha} onChange={(e) => setFecha(e.target.value)} />
              </Col>
              <Col md={3}>
                <Label>Almacen</Label>
                <Input type="select" value={area} onChange={(e) => setArea(e.target.value)}>
                  {areas.map((a) => (
                    <option value={a._id} key={a._id}>{a.name}</option>
                  ))}
                </Input>
              </Col>
              <Col md={6}>
                <Label>Observaciones</Label>
                <Input value={observaciones} onChange={(e) => setObservaciones(e.target.value)} placeholder="Motivo de la salida" />
              </Col>
            </Row>
            <br />
            <CapturaMateriales
              renglones={renglones}
              setRenglones={setRenglones}
              telas={telas}
              habilitacion={habilitacion}
              colores={colores}
              opcionesDe={(tipo) => materialesConExistencia(existencias, tipo === "Telas" ? telas : habilitacion, tipo)}
              coloresDe={coloresConExistencia(existencias, colores)}
              limiteDe={limiteDisponible(existencias)}
            />
            <div className="submit-bar">
              <Button href="/ListadoSalidaTelas" className="btn btn-danger">Regresar</Button>
              <Button type="submit" className="btn btn-success" disabled={guardando}>
                <i className="fas fa-save" style={{ marginRight: 6 }} /> Guardar
              </Button>
            </div>
          </Form>
          <br />
        </div>
      ) : undefined}
    </>
  );
}

export default SalidaMaterialesCreate;
